export default "__VITE_ASSET__CLr9X4H6__"